// extracted by mini-css-extract-plugin
module.exports =  {"link-to-details":"_32bbee5fda--link-to-details--mILQe"};